module.exports = __webpack_public_path__ + "img/presse_cafe.ca4a136b.png";